import { LOCAL } from "@/store/mutations";

const { SET_FUND_BALANCE } = LOCAL;

export default {
	namespaced: true,
	state: () => ({
		id: null,
		name: "",
		balance: 0,
		spendable: false,
		minimum_winning_balance: 0,
	}),
	getters: {
		hasWinningBalance: (state) => state.balance >= state.minimum_winning_balance,
		balanceNeeded: (state) => (state.spendable ? 0 : state.minimum_winning_balance - state.balance),
	},
	actions: {
		deposit({ state, commit }, budget) {
			const balance = state.balance + budget.amount;
			commit(SET_FUND_BALANCE, { balance });
		},
		withdraw({ state, commit }, budget) {
			const balance = state.balance - budget.amount;
			commit(SET_FUND_BALANCE, { balance });
		},
	},
	mutations: {
		[SET_FUND_BALANCE](state, fund) {
			state.balance = fund.balance;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/funds/single.store.js